import { useEffect, useState } from "react";

// core
import { API } from "../core/api";

// components
import { Header } from "../components/Header";
import { Loading } from "../components/Loading";
import { StaticCard } from "../components/StaticCard";
import { Note } from "../components/Note";
import { addTomanPriceComma, useHistory } from "../core/utils";

// icons
import City from "../assets/svg/city-icon.svg";
import Car from "../assets/svg/car-icon.svg";
import Credit from "../assets/svg/credit-icon.svg";
import Driver from "../assets/svg/driver-icon.svg";
import Message from "../assets/svg/message-icon.svg";
import Product from "../assets/svg/product-icon.svg";
import Repair from "../assets/svg/repair-icon.svg";
import { useSelector } from "react-redux";
export const Home = () => {
  const store = useSelector((state) => state?.Store);
  const [dashboard, setDashboard] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const getDashboard = () => {
    // setIsLoading(true);
    // API.get
    //   .dashboard()
    //   .then((response) => {
    //     if (response.success) {
    //       setDashboard(response.data);
    //       setIsLoading(false);
    //     } else {
    //       Note.error(response.message);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoading(false);
    //   });
  };
  useEffect(() => {
    if (store.user?.is_login) {
      getDashboard();
    }
  }, [store.user.is_login]);

  console.log(store);

  return (
    <>
      <Header title="Fleet Management" activeItem="Dashboard" />
      <Loading isLoading={isLoading}>
        <div className="home-page">
          <div className="home-page-items-container">
            <StaticCard
              className="w-100"
              name="Cities"
              value={`${dashboard.cities_quantity || 4} cities`}
              icon={City}
              onClick={() => history.push("/cities-and-users/")}
            />
            <StaticCard
              className="w-100"
              name="Employees"
              value={`${dashboard.employees_quantity || 5} users`}
              icon={Driver}
              onClick={() => history.push("/cities-and-users/")}
            />
            <StaticCard
              className="w-100"
              name="Cars"
              value={`${dashboard.cars_quantity || 5} cars`}
              icon={Car}
              onClick={() => history.push("/cars/")}
            />
            <StaticCard
              className="w-100"
              name="Drivers"
              value={`${dashboard?.drivers_quantity || 5} drivers`}
              icon={Driver}
              onClick={() => history.push("/drivers/")}
            />
            <StaticCard
              className="w-100"
              name="Credit"
              value={`${addTomanPriceComma(dashboard.credit_amount || 3000000)} USD`}
              icon={Credit}
              onClick={() => history.push("/credit/")}
            />
            <StaticCard
              className="w-100"
              name="Purchases"
              value={`${dashboard.orders_quantity || 5} products`}
              icon={Product}
              onClick={() => history.push("/buy-product-report/")}
            />
            <StaticCard
              className="w-100"
              name="Services"
              value={`${dashboard.bills_quantity || 5} cars`}
              icon={Repair}
              onClick={() => history.push("/cars-service-report/")}
            />
            <StaticCard
              className="w-100"
              name="Notifications"
              value={"0 Notifications"}
              icon={Message}
              onClick={() => history.push("/notifications/")}
            />
          </div>
          <div className=" go-to-website cursor-pointer">
            <a href={`https://higaraj.com`} target="_blank" rel="noreferrer">
              <button className="button-secondary">Go to HiG</button>
            </a>
          </div>
        </div>
      </Loading>
    </>
  );
};
